















import {Component, Vue} from 'vue-property-decorator';
import {AppInfo} from '@/models/AppInfo';
import {namespace} from 'vuex-class';

const AppInfoStore = namespace('AppInfoStore');

@Component({
    name: 'PrivacyPolicy',
})

export default class PrivacyPolicy extends Vue {

    @AppInfoStore.State
    public info!: AppInfo;

    public loading: boolean = false;
    public showDialog: boolean = false;
}
